<!-- Slideout setting section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title" cvLocalizedText langSection="Frustration_Widget" langKey="Frustration_Settings">
        <!-- The header of this section -->
        Frustration Settings
    </div>
    <div class="custom-setting-section-context">
        <!-- Context beneath the header, usually showing an overview of what is selected without expanding the section -->
        {{ getFrustationContext() }}
    </div>
    <div class="custom-setting-section-body">
        <!-- The controls to change settings, will be shown when the section is expanded -->
        <div class="mb-2 font-size-12" cvLocalizedText langSection="Frustration_Widget" langKey="Data_Set">Data Set</div>
        <select class="form-control mb-3" [(ngModel)]="frustrationDataset" [compareWith]="datasetComparer">
            <option *ngFor="let dataset of frustrationDatasetList;" [ngValue]="dataset">{{ dataset.DatasetName }}</option>
        </select>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection position="top" [moduleManager]="moduleManager">
        <!-- Any settings you want above the generic settings will go here -->
        <div class="mb-2 font-size-12" cvLocalizedText langSection="Frustration_Widget" langKey="Data_Set">Data Set</div>
        <select class="form-control mb-3" [(ngModel)]="frustrationDataset" [compareWith]="datasetComparer">
            <option *ngFor="let dataset of frustrationDatasetList;" [ngValue]="dataset">{{ dataset.DatasetName }}</option>
        </select>
    </div>

    <!-- Generic settings will be in between -->

    <div cvModuleLegacyCustomSettingSection position="bottom" [moduleManager]="moduleManager">
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
   <div class="mb-2 font-size-12" cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager">
        <label cvLocalizedText langSection="Frustration_Widget" langKey="Data_Set">Data Set</label>
        <cxone-singleselect-dropdown 
            id="cxone-dropdown-1" 
            [(ngModel)]="frustrationDataset" 
            [options]="frustrationDatasetList" 
            [label]="'DatasetName'"
            [primaryKey]="'DatasetId'" 
            [isRequired]="false" 
            [sortOrder]="'asc'"
            [maxItemsToDisplay]="1000">
        </cxone-singleselect-dropdown>
    </div>

</ng-container>
